import React from 'react';
import "./src/styles/global.css"
import Layout from './src/components/Layout';


/**
 * 
 * @param {import('gatsby').WrapPageElementBrowserArgs} param0 
 * @returns 
 */
export const wrapPageElement = ({ element, props }) => {
    return <Layout {...props}> {element} </Layout>
}